import React from 'react'
import { Route, Routes, useNavigate } from 'react-router-dom'

import SuccessPage from './Success'
import ConfirmationPage from './Confirmation'
import ShippingPage, { FormData as ShippingFormData } from './Shipping'
import IntellitagsPage, { FormData as IntellitagsFormData } from './Intellitags'
import AccountPage, { FormData as AccountFormData } from './Account'
import RedemptionCodesPage from './RedemptionCodes'
import { usePersistedState } from 'hooks/persisted-state'
import type { OrderRedemptionInput } from 'services/order-redemtions'

type FormData = Partial<OrderRedemptionInput>

const LOCAL_STORAGE_KEY = 'order-redemption-state'

function OrderRedemptionPage() {
  const navigate = useNavigate()
  const [state, setState] = usePersistedState<FormData>({}, LOCAL_STORAGE_KEY)

  function handleConfirmationSubmit() {
    localStorage.removeItem(LOCAL_STORAGE_KEY)
    navigate('success')
  }

  function handleShippingSubmit(values: ShippingFormData) {
    setState((s) => ({ ...s, shippingAddress: values }))
    navigate(`confirmation`)
  }

  function handleIntellitagsSubmit(values: IntellitagsFormData) {
    setState((s) => ({ ...s, order: values }))
    navigate(`shipping`)
  }

  function handleAccountSubmit(values: AccountFormData) {
    setState((s) => ({ ...s, user: values }))
    navigate(`intellitags`)
  }

  function handleRedemptionCodeSubmit(values: string[]) {
    setState((s) => ({ ...s, codes: values }))
    navigate(`account`)
  }

  return (
    <Routes>
      <Route path='success' element={<SuccessPage />} />
      <Route
        path='confirmation'
        element={
          <ConfirmationPage
            state={state}
            onSuccess={handleConfirmationSubmit}
          />
        }
      />
      <Route
        path='shipping'
        element={<ShippingPage state={state} onSubmit={handleShippingSubmit} />}
      />
      <Route
        path='intellitags'
        element={
          <IntellitagsPage state={state} onSubmit={handleIntellitagsSubmit} />
        }
      />
      <Route
        path='account'
        element={<AccountPage state={state} onSubmit={handleAccountSubmit} />}
      />
      <Route
        index
        element={
          <RedemptionCodesPage
            state={state}
            onSubmit={handleRedemptionCodeSubmit}
          />
        }
      />
    </Routes>
  )
}

export default OrderRedemptionPage
